module.exports = __webpack_public_path__ + "static/media/mason.f1572fa7.png";